import { View } from 'react-native';

import { Button, IconClose, IconStarRateFill, Text, XStack, tokens } from '@fhs/ui';
import { Badge } from '@fhs/ui/src/components/badge/badge';
import { actions, useAppDispatch } from '@fhs-legacy/frontend/src/state/global-state';
import { useLoyaltyUser } from '@fhs-legacy/frontend/src/state/loyalty/hooks/use-loyalty-user';
import { HapticsNotificationType, hapticNotification } from '@fhs-legacy/frontend/src/utils/haptic';
import { REMOVE_REWARD, REWARD_IN_USE } from '@fhs-legacy/frontend/src/utils/test-ids';

import { IRewardBarComponentProps, styles } from './typesAndStyles';

export default function RewardInUse({ cartId, loyaltyRewardAvailable }: IRewardBarComponentProps) {
  const dispatch = useAppDispatch();
  const { loyaltyUser } = useLoyaltyUser();

  const handleRemoveReward = () => {
    const { unApplyReward, setIsPricingRewardApplication } = actions.loyalty;
    dispatch(setIsPricingRewardApplication(true));

    dispatch(
      unApplyReward({
        cartId,
        rewardBenefitId: loyaltyRewardAvailable.rewardBenefitId,
        loyaltyUser,
      })
    );
    hapticNotification({ type: HapticsNotificationType.SUCCESS });
  };

  return (
    <XStack testID={REWARD_IN_USE} style={[styles.redeemContainer, styles.active]}>
      <Badge>Reward</Badge>
      <View style={styles.spacer} />
      <View
        style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}
      >
        <Button.Icon color={tokens.colors.$houseYellow}>
          <IconStarRateFill />
        </Button.Icon>
        <Text.Ui size="sm">Using</Text.Ui>
        <Text.Ui size="sm" weight="bold">
          {/* needs spaces */}
          {' ' + loyaltyRewardAvailable.pointCost + ' '}
        </Text.Ui>
        <Text.Ui size="sm">Points</Text.Ui>
      </View>
      <View style={styles.spacer} />
      <Button testID={REMOVE_REWARD} type="outline" onPress={handleRemoveReward}>
        <Button.Icon>
          <IconClose />
        </Button.Icon>
      </Button>
    </XStack>
  );
}
